import { useContext, useEffect, useRef } from 'react';
import { MyWorkContext } from '../MyWorkContextProvider';
import { lanesStillRefreshing } from './lanePaging';

// Refresh on My Work's board: the toolbar bumps myWorkStates.boardRefresh and sets boardLanesRefreshing to the
// number of lanes mounted (boardLaneCount). Each lane loads again with its cards left on screen (no skeleton) and
// calls done() with the Refresh it started from when it has finished, so the board stays dimmed and frozen until the
// last lane of the latest Refresh lands. The lanes are counted rather than assumed: a lane hidden from the board
// (BoardView's element.hidden) is not mounted, so loads nothing.
const mountedLanes = new Set<object>();
export const boardLaneCount = () => mountedLanes.size;

export const useBoardLaneRefresh = () => {
  const { myWorkStates, setMyWorkStates } = useContext(MyWorkContext);
  const refreshKey = myWorkStates.boardRefresh ?? 0;
  const seen = useRef(refreshKey);
  const lane = useRef({});

  useEffect(() => {
    const id = lane.current;
    mountedLanes.add(id);
    return () => { mountedLanes.delete(id); };
  }, []);

  // True once per new refreshKey: this load came from Refresh, not from mounting or Show Closed.
  const takeRefresh = () => {
    const isRefresh = refreshKey !== seen.current;
    seen.current = refreshKey;
    return isRefresh;
  };

  const done = (refresh: number) => setMyWorkStates(prev => ({ ...prev, boardLanesRefreshing: lanesStillRefreshing(prev, refresh) }));

  return { refreshKey, takeRefresh, done };
};
